import { PrimaryControlsStripTitle } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.title";
import { SuspensePageBoundary } from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { View } from "@-/com.npmjs.react-native";
import { DeckUpcomingPageLoadingFallback } from "#deck-upcoming-page-loading-fallback";
import { DeckUpcomingPageSuspense } from "#deck-upcoming-page-suspense";

export function DeckUpcomingPage({ today = false }: { today?: boolean } = {}) {
  return (
    <>
      <PrimaryControlsStripTitle>Deck</PrimaryControlsStripTitle>
      <View className="flex-1 bg-background">
        <SuspensePageBoundary
          fallback={<DeckUpcomingPageLoadingFallback today={today} />}
          location={import.meta.location}
        >
          <DeckUpcomingPageSuspense today={today} />
        </SuspensePageBoundary>
      </View>
    </>
  );
}
